import { IUser } from '@/utils/types/User';
import { IDeposit } from '@/utils/types/IDeposit';
import { ICaseBattleGame, TCaseBattleTypes } from '@/utils/types/ICaseBattle';

export const defaultUser: IUser = {
    id: -1,
    steamid: '',
    name: '',
    status: 'USER',
    isFake: true,
    avatar: '',
    tradeToken: null,
    level: -1,
    experience: -1,
    balanceUsd: -1,
    balanceUsdHold: -1,
    steamInventoryBalanceUsd: -1,
    withdrawRestrictionText: null,
};

export const WITHDRAW_RESTRICTION_DEFAULT_TEXT =
    'You have withdrawal restrictions. For more details, please read the site rules. If you have any questions, contact support.';

export const statuses: { [key in IDeposit['status']]: string } = {
    DECLINED: 'bg-red/10 text-red',
    COMPLETED: 'bg-green/10 text-green',
    PENDING: 'bg-yellow/10 text-yellow',
};

export const currencyIcons = {
    TRX: 'trx.svg',
    USDT: 'usdt.svg',
    BTC: 'bitcoin.svg',
    ETH: 'ethereum.svg',
};
export const reactSelectColors = {
    primary: '#2D3032',
    primary75: '#F2C960',
    primary50: '#F2C960',
    primary25: '#F2C960',

    neutral0: '#2D3032',
    neutral5: '#2D3032',
    neutral10: '#2D3032',
    neutral20: '#2D3032',
};
export const gamesData = {
    csgo: { appId: 730, contextId: 2, name: 'CS:GO' },
    rust: { appId: 252490, contextId: 2, name: 'RUST' },
    dota: { appId: 570, contextId: 2, name: 'DOTA 2' },
};

// Громкость всех звуков на сайте
export const soundsVolume = 0.2;

// Setup before launch
export const DEFAULT_GAME: keyof typeof gamesData = 'rust';
export const ENABLED_GAMES: Array<keyof typeof gamesData> = ['csgo', 'rust', 'dota'];

export const CaseBattleTypes: {
    type: TCaseBattleTypes;
    span: string;
}[] = [
    {
        type: 'STANDARD_2',
        span: '2',
    },
    {
        type: 'STANDARD_3',
        span: '3',
    },
    {
        type: 'STANDARD_4',
        span: '4',
    },
    {
        type: 'STANDARD_5',
        span: '5',
    },
    {
        type: 'STANDARD_6',
        span: '6',
    },
    {
        type: 'TWO_VS_TWO',
        span: '2V2',
    },
];

// tailwind.config.ts > safelist добавить grid-cols
export const TypesToCount: Record<ICaseBattleGame['type'], string> = {
    STANDARD_2: '2',
    STANDARD_3: '3',
    STANDARD_4: '4',
    STANDARD_5: '5',
    STANDARD_6: '6',
    TWO_VS_TWO: '4',
};

// One more url is located in utils/hooks/use-subscription.ts
export const HOST = 'https://rustyhunt.com/';
// NEXT_PUBLIC_* vars are inlined at build time. NODE_ENV !== 'production' guard
// makes sure that even if someone runs `next build` with NEXT_PUBLIC_DEV=true
// still set in their shell or .env, the prod bundle uses '/' as origin.
export const BACKEND_URL =
    process.env.NODE_ENV !== 'production' && process.env.NEXT_PUBLIC_DEV === 'true'
        ? HOST
        : '/';

// Сколько коинфлип будет висеть после завершения
export const COINFLIP_LIFETIME = 20;

// Сколько батл будет висеть после завершения
export const BATTLE_LIFETIME = 20;
// Server fires a fresh roll every 5000ms. Phase 2 + reveal in BattleRouletteSlider
// add ~790ms after the glide, so capping the glide at 3000ms leaves ~1.2s for the
// previous result to breathe on screen before the next scroll starts.
export const DEFAULT_ANIMATION_TIME = 3000;

export const SUPPORT_ID = 311;

export const JACKPOT_SKIN_LIMIT = 10;
